export const calendarList = () => ({
  currentPage: 1,
  maxPages: 1,
  loadingNext: false,
  filtersHasScroll: false,
  openFilters: false,

  init() {
    window.addEventListener('resize', () => {
      this.checkFiltersScroll();
    });

    this.$watch('openFilters', (value: boolean) => {
      if (value) {
        this.$nextTick(() => {
          this.checkFiltersScroll();
        });
      }
    });
  },

  openModal() {
    this.openFilters = true;
  },

  closeModal() {
    this.openFilters = false;
  },

  checkFiltersScroll() {
    if (this.$refs.filtersContent) {
      this.filtersHasScroll =
        this.$refs.filtersContent.scrollHeight >
        this.$refs.filtersContent.clientHeight;
    }
  },

  /**
   * Handle filter checkbox change.
   * For f_month[] checkboxes: three mutually exclusive groups -
   *   "all" (standalone), months (multi-select), "archive" (standalone).
   * Builds the correct URL directly instead of relying on form submission,
   * to avoid conflicts with Alpine's x-model on checkbox components.
   */
  onMonthFilterChange(event: Event) {
    const checkbox = event.target as HTMLInputElement;
    const form = checkbox.closest('form');
    if (!form) return;

    // For non-month filters, just submit the form
    if (checkbox.name !== 'f_month[]') {
      form.requestSubmit();
      return;
    }

    const url = new URL(window.location.href);
    url.searchParams.delete('f_month[]');
    url.searchParams.delete('paged');

    const value = checkbox.value;

    if (value === 'all') {
      // "All" = no month filter, just navigate without f_month
    } else if (value === 'archive') {
      // "Archive" = standalone
      url.searchParams.append('f_month[]', 'archive');
    } else {
      // Month clicked - get currently selected months from URL, toggle this one
      const currentMonths = new URL(window.location.href).searchParams
        .getAll('f_month[]')
        .filter((m) => m !== 'all' && m !== 'archive');

      let newMonths: string[];
      if (checkbox.checked) {
        // Adding a month
        newMonths = [...currentMonths, value];
      } else {
        // Removing a month
        newMonths = currentMonths.filter((m) => m !== value);
      }

      // If no months left, default to "all" (no params)
      newMonths.forEach((m) => url.searchParams.append('f_month[]', m));
    }

    window.location.href = url.toString();
  },

  getPageUrl(page: number): string {
    const url = new URL(window.location.href);
    url.searchParams.set('paged', page.toString());
    return url.toString();
  },
});
